export const CANCEL_BUTTON_TEXT = 'Cancel';
export const CONFIRM_BUTTON_TEXT = 'Reset All';
export const HEADER_TEXT = 'Are You Sure?';
